// extracted by mini-css-extract-plugin
export default {"footerLogo":"FooterLogo_footerLogo__p72Uv"};